import { __rest } from '../../../../../node_modules/tslib/tslib.es6.mjs.js';
import React from 'react';
import { useSampleData } from '../../../../components/UseSampleData.js';
import { useAppSelector } from '../../../../hooks/hooks.js';
import { selectMode } from '../../../../store/reducers/enginePropertiesSlice.js';
import C2DataTableChild from './C2DataTableChild.js';

function C2DataTable(props) {
    var _a, _b, _c;
    const mode = useAppSelector(selectMode);
    const id = ((_a = props.id) === null || _a === void 0 ? void 0 : _a.startsWith("cmp-")) ? props.id.substring(4) : props.id;
    const sample = useSampleData(id);
    const value = mode === "design" ? (_b = sample.data) !== null && _b !== void 0 ? _b : [] : (_c = props.value) !== null && _c !== void 0 ? _c : [];
    const loading = mode === "design" ? sample.isLoading : props.loading;
    // destructre props to remove isSampleLoading, sampleValue, cols, and colMapping
    // which are legacy properties, will be removed with a DB migration later
    const rest = __rest(props, ["isSampleLoading", "sampleValue", "cols", "colMapping"]);
    return React.createElement(C2DataTableChild, Object.assign({}, rest, { value: value, mode: mode, loading: loading }));
}

export { C2DataTable as default };
//# sourceMappingURL=C2DataTable.js.map
